require('../../modules/es.string.starts-with');

module.exports = require('../../internals/entry-unbind')('String', 'startsWith');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/es/string/starts-with.js
// module id = 550
// module chunks = 0